const RICOS_VERSION = "10.134.2";
export {
  RICOS_VERSION
};
//# sourceMappingURL=version.js.map
